import React, { useState } from 'react';
import { Download, Send, Search, FileText, Clock, Users } from 'lucide-react';
import useGroupProjectManagementStore from '@/stores/AdminStore/GroupProjectManagementStore';
import './SubmissionsGrading.css';

const SubmissionGradingUI: React.FC = () => {
  const { submissions } = useGroupProjectManagementStore();

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('Select Team');
  const [selectedStatus, setSelectedStatus] = useState('Submitted Status');
  const [grade, setGrade] = useState('');
  const [feedback, setFeedback] = useState('');

  const submission = submissions?.[0];

  const handleSubmitGrade = () => {
    if (grade && feedback) {
      alert(`Grade: ${grade}%\nFeedback: ${feedback}`);
    }
  };

  if (!submission) {
    return (
      <div className="trainer-group-submission-grading-container">
        <div className="trainer-group-submission-grading-filters">
          <div className="trainer-group-submission-grading-search">
            <Search className="trainer-group-submission-grading-search-icon" size={20} />
            <input
              type="text"
              placeholder="Search & Select project"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="trainer-group-submission-grading-search-input"
            />
          </div>

          <div className="trainer-group-submission-grading-dropdown">
            <select
              value={selectedTeam}
              onChange={(e) => setSelectedTeam(e.target.value)}
              className="trainer-group-submission-grading-select"
            >
              <option>Select Team</option>
              <option>Design Squad</option>
              <option>Dev Team</option>
              <option>Marketing Team</option>
            </select>
          </div>

          <div className="trainer-group-submission-grading-dropdown">
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="trainer-group-submission-grading-select"
            >
              <option>Submitted Status</option>
              <option>Submitted</option>
              <option>Graded</option>
              <option>Pending</option>
            </select>
          </div>
        </div>
        <p>No submissions found</p>
      </div>
    );
  }

  return (
    <div className="trainer-group-submission-grading-container">
      <div className="trainer-group-submission-grading-filters">
        <div className="trainer-group-submission-grading-search">
          <Search className="trainer-group-submission-grading-search-icon" size={20} />
          <input
            type="text"
            placeholder="Search & Select project"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="trainer-group-submission-grading-search-input"
          />
        </div>

        <div className="trainer-group-submission-grading-dropdown">
          <select
            value={selectedTeam}
            onChange={(e) => setSelectedTeam(e.target.value)}
            className="trainer-group-submission-grading-select"
          >
            <option>Select Team</option>
            <option>Design Squad</option>
            <option>Dev Team</option>
            <option>Marketing Team</option>
          </select>
        </div>

        <div className="trainer-group-submission-grading-dropdown">
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="trainer-group-submission-grading-select"
          >
            <option>Submitted Status</option>
            <option>Submitted</option>
            <option>Graded</option>
            <option>Pending</option>
          </select>
        </div>
      </div>

      <div className="trainer-group-submission-grading-card">
        <div className="trainer-group-submission-grading-header">
          <div className="trainer-group-submission-grading-title-section">
            <h2 className="trainer-group-submission-grading-title">{submission.projectName}</h2>
            <span className="trainer-group-submission-grading-badge">{submission.status}</span>
          </div>

          <div className="trainer-group-submission-grading-members">
            <Users size={18} className="trainer-group-submission-grading-members-icon" />
            <span className="trainer-group-submission-grading-members-text">
              {submission.teamMembers.map((member, index) => (
                <React.Fragment key={index}>
                  {member.name}
                  {index < submission.teamMembers.length - 1 && ', '}
                </React.Fragment>
              ))}
            </span>
          </div>
        </div>

        <div className="trainer-group-submission-grading-files-section">
          <h3 className="trainer-group-submission-grading-files-title">Submitted Files</h3>

          {submission.files.map((file, index) => (
            <div key={index} className="trainer-group-submission-grading-file-item">
              <div className="trainer-group-submission-grading-file-info">
                <FileText size={18} className="trainer-group-submission-grading-file-icon" />
                <span className="trainer-group-submission-grading-file-name">{file.name}</span>
              </div>
              <button className="trainer-group-submission-grading-download-btn">
                <Download size={18} />
              </button>
            </div>
          ))}
        </div>

        <div className="trainer-group-submission-grading-date">
          <Clock size={16} className="trainer-group-submission-grading-date-icon" />
          <span>Submitted on {submission.submittedDate}</span>
        </div>

        <div className="trainer-group-submission-grading-form">
          <div className="trainer-group-submission-grading-input-group">
            <label className="trainer-group-submission-grading-label">Grade (%)</label>
            <input
              type="number"
              placeholder="Enter grade"
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
              className="trainer-group-submission-grading-input"
              min="0"
              max="100"
            />
          </div>

          <div className="trainer-group-submission-grading-input-group">
            <label className="trainer-group-submission-grading-label">Feedback</label>
            <textarea
              placeholder="Provide feedback to the team..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="trainer-group-submission-grading-textarea"
              rows={4}
            />
          </div>

          <button
            onClick={handleSubmitGrade}
            className="trainer-group-submission-grading-submit-btn"
          >
            <Send size={18} />
            Submit Grade & Feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionGradingUI;
